import React from 'react';

import ButtonDropdown from 'components/ButtonDropdown';
import {formatDate} from 'utils/datetime';

import './styles.css';

const BaseInformation = ({
  payment,
  voidTransaction,
  syncPayment,
  addXeroIdToPayment
}) => {
  return (
    <div className="BaseInformation">
      <div className="data">
        <div className="section">
          <div className="header">Payment Date</div>
          <div className="text">
            {formatDate(payment.transaction.paymentDate)}
          </div>
        </div>
        <div className="section">
          <div className="header">Account</div>
          <div className="text">{`${payment.xeroAccount.code} - ${
            payment.xeroAccount.name
          }`}</div>
        </div>
        <div className="section">
          <div className="header">Stripe Id</div>
          <div className="text">{payment.stripeId || 'N/A'}</div>
        </div>
      </div>
      <div className="options">
        <ButtonDropdown
          title="Transaction options"
          menuPosition={ButtonDropdown.MENU_POSITION_BOTTOM}>
          <ButtonDropdown.Option
            disabled={!payment.transaction.isVoidable}
            onClick={voidTransaction}>
            Void transaction
          </ButtonDropdown.Option>
          <ButtonDropdown.Option
            disabled={!payment.isSyncable}
            onClick={syncPayment}>
            Sync payment
          </ButtonDropdown.Option>
          <ButtonDropdown.Option
            disabled={payment.xeroId}
            onClick={addXeroIdToPayment}>
            Add Xero ID
          </ButtonDropdown.Option>
        </ButtonDropdown>
      </div>
    </div>
  );
};

export default BaseInformation;
